export interface DeviceBehfa_Gostareh_Interface {
  id:number,
  max:number,
  min:number,
  zineh:number,
  vahed_id:number,
  vahed_title:string,

  error:string,
  error_vahed_id:number,
  error_vahed_title:string,
}

export function Empty_DeviceBehfa_Gostareh_Interface():DeviceBehfa_Gostareh_Interface{
  return{
    id:0,
    max:0,
    min:0,
    zineh:0,
    vahed_id:0,
    vahed_title:'',

    error:'',
    error_vahed_id:0,
    error_vahed_title:'',
  }
}
